import { useNavigate } from 'react-router-dom'
import { Users, Globe, Bell, Shield, ChevronRight } from 'lucide-react'
import { TopBar } from '../../components/layout/TopBar'
import { Card } from '../../components/ui/Card'

const ITEMS = [
  {
    icon: Users,
    label: 'Benutzer verwalten',
    desc: 'Techniker und Verkäufer hinzufügen',
    color: 'text-blue-600 bg-blue-50',
    to: '/einstellungen/benutzer',
  },
  {
    icon: Globe,
    label: 'BEXIO Anbindung',
    desc: 'Artikel-Sync und API-Konfiguration',
    color: 'text-green-600 bg-green-50',
    to: null,
  },
  {
    icon: Bell,
    label: 'Benachrichtigungen',
    desc: 'Push-Nachrichten und E-Mail',
    color: 'text-amber-600 bg-amber-50',
    to: null,
  },
  {
    icon: Shield,
    label: 'Datenschutz',
    desc: 'Datenspeicherung und Zugriffsrechte',
    color: 'text-purple-600 bg-purple-50',
    to: null,
  },
]

export function EinstellungenPage() {
  const navigate = useNavigate()

  return (
    <>
      <TopBar title="Einstellungen" backTo="/mehr" />
      <div className="px-4 py-3 space-y-2 pb-8">
        {ITEMS.map((item) => (
          <Card
            key={item.label}
            clickable={!!item.to}
            onClick={item.to ? () => navigate(item.to!) : undefined}
            className={`flex items-center gap-4 ${!item.to ? 'opacity-50' : ''}`}
          >
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${item.color}`}>
              <item.icon size={18} />
            </div>
            <div className="flex-1">
              <p className="font-medium text-gray-900">{item.label}</p>
              <p className="text-xs text-gray-500">{item.desc}</p>
            </div>
            {item.to ? (
              <ChevronRight size={18} className="text-gray-400 shrink-0" />
            ) : (
              <span className="text-xs text-gray-400 bg-gray-100 px-2 py-1 rounded-full shrink-0">Bald</span>
            )}
          </Card>
        ))}
      </div>
    </>
  )
}
